// extracted by mini-css-extract-plugin
export default {"register":"register_register__Nn4lq","form":"register_form__W4Aqs","links":"register_links__ptmxU","input":"register_input__vTydQ"};